import './App.css';
import React, { useState, useEffect, useRef } from 'react';
import { StepsViewer } from './components/StepsViewer';
import { Config } from './Config';
import Footer from './components/Footer';
import Header from './components/Header';
import API from './library/ApiManager'
import Loading from './components/Loading';
import Fatturazione from './components/steps/Fatturazione';
import DemetraMetodiPagamento from './components/steps/DemetraMetodiPagamento';
import OrdineCompletato from './components/steps/OrdineCompletato';
import Fnc from './library/Functions';
import {
  Routes,
  Route,
  useNavigate
} from "react-router-dom";
import Basket from './components/Basket';
import ConfigurazioneSito from './components/steps/ConfigurazioneSito';
import { isCommissionSelectable } from './components/steps/CommissionUtils';
import './CheckoutRestyling.css';


/**
 * Componente principale dell'applicazione Carrello.
 * Gestisce tutte le parti della pagina che sono modularizzate e separate in componenti secondari.
 * Nel file Confing.js della root, sono presenti impostazioni generali di primaria importanza per il funzionamento di tutte le parti.
 *
 * @version 1.0.0
 * @author [Davide Pirola]
 */
function App() {
  const [currStep, setCurrStep] = useState(null);
  const [user, setUser] = useState(null);
  const [bskType, setBskType] = useState(Fnc.BasketType.PAY);
  //const [basket, setBasket] = useState(null);
  const [selComm, setSelComm] = useState(null);
  const [loadingState, setLoadingState] = useState("open");
  //const [chooseCommStep, setChooseCommStep] = useState(false);
  //const [chooseDomainStep, setChooseDomainStep] = useState(false);
  const [invoice, setInvoice] = useState(readConfirmedInvoiceFromSession);
  const [payResult, setPayResult] = useState(null);
  const [validBasket, setValidBasket] = useState(true);
  const [customer, setCustomer] = useState(null);
  const [showBasket, setShowBasket] = useState(false);
  //const [basketProds, setBasketProds] = useState(false);
  const checkoutCompletedRef = useRef(false);

  const navigate = useNavigate();

  const defaultStep = Config.stepList.find(function (el) {
    return el.default;
  })

  useEffect(() => {

    Fnc.log("v."+Config.version, Fnc.currEnv().type, Fnc.LogLvl.INFO);

    // Similar to componentDidMount and componentDidUpdate:
    let defStep = Config.stepList.find(function (el) {
      return el.default;
    });
    setCurrStep(Fnc.getStepByUrl() || defStep);

    let courtesyTime = Fnc.checkState(1);

    if(courtesyTime) {
      navigate(Fnc.currEnv().courtesyPage);
    } else {
      jobFirstTimeLoad();
    }
   

  }, []); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

  function getSelComm() {
    return JSON.parse(sessionStorage.getItem(Fnc.selCCName));
  }


  function jobFirstTimeLoad() {
    setLoadingState("open");
    getUser();
  }

  // === STEP2- [USER] : controllo utente e sue commissioni ========
  function getUser() {
    //Recuperiamo dati utente per verificare se è loggato e agire di conseguenza nel layout
    API.getUser((data) => {

      if (!data || !data.user) {
        setStep(-1);
        setLoadingState("");
        setShowBasket(false);
        Fnc.gaException("[App.js@getUser] Get User vuota", null, true, Fnc.ExcCatgory.USER.val);
        return;
      }

      const commissionList = data.user.commissionList;
      if (commissionList && !commissionList.commissions) {
        // Una lista mancante resta un errore di risposta, non equivale a zero contratti.
        setStep(-1);
        setLoadingState("");
        setShowBasket(false);
        Fnc.gaException("[App.js@getUser] Get User con commissionList ma senza commissions", null, true, Fnc.ExcCatgory.USER.val);
        return;
      }

      const now = Date.now();
      // La consistenza arriva con onlyActive=true: SF determina la scadenza.
      const commissions = commissionList?.commissions || [];
      const selectableCommissions = commissions
        .filter(commission => isCommissionSelectable(commission, now));
      const currentUser = commissionList ? {
        ...data,
        user: { ...data.user, commissionList: { ...commissionList, commissions } }
      } : data;

      if (data.response?.code !== 'OK') {
        setUser(currentUser);
        setLoadingState("");
        setShowBasket(true);
        return;
      }

      const previousCommission = getSelComm();
      const selectedCommission = selectableCommissions.length === 1
        ? selectableCommissions[0]
        : selectableCommissions.find(commission => commission.codComm === previousCommission?.codComm);

      if (selectableCommissions.length > 0 && !selectedCommission) {
        sessionStorage.removeItem(Fnc.selCCName);
        setSelComm(null);
        setUser(currentUser);
        setLoadingState("");
        setShowBasket(false);
        return;
      }

      if (!selectedCommission) {
        sessionStorage.removeItem(Fnc.selCCName);
        setSelComm(null);
      }

      // Allinea il cookie prima di caricare il customer e validare il carrello.
      // Senza contratti attivi elimina anche un'associazione conservata da un ingresso precedente.
      sendCommToBE(selectedCommission, () => {
        API.getCustomer(data.user.pIva, (custRsp) => {
          if (custRsp?.response?.code === 'OK') {
            if (selectedCommission) setComm(selectedCommission);
            setCustomer(custRsp);
            setUser(currentUser);
            setLoadingState("");
            setShowBasket(true);
          } else {
            setStep(-1);
            setLoadingState("");
            setShowBasket(false);
            Fnc.gaException("[App.js@getUser] Get Customer ha dato esito KO", JSON.stringify(custRsp), true, Fnc.ExcCatgory.USER.val);
          }
        });
      });

    });
  }

  function sendCommToBE(comm, callback) {
    API.addValue("CODCOMM", comm ? comm.codComm : null, (data) => {
      if (!(data && data.response && data.response.code === 'OK')) {
        // ERRORE
        setStep(-1);
        setLoadingState("");
        setShowBasket(false);
        Fnc.gaException("[App.js@sendCommToBE] Aggiunta codice commissione al cookie in KO", JSON.stringify(data), true, Fnc.ExcCatgory.GENERIC.val);
        return;
      }
      callback();
    });
  }

  function handleNext() {
    let stepByUrl = Fnc.getStepByUrl();
    let nextIdx = stepByUrl.idx + 1;
    setStep(nextIdx);
  }

  function setStep(idx) {
    let stepByUrl = Fnc.getStepByUrl();
    if (stepByUrl.idx !== idx) { // Prevengo doppie chiamate
      let selectedStep = Config.stepList.find(function (el) {
        return el.idx === idx;
      })
      setCurrStep(selectedStep);
      navigate(selectedStep.path);
    }
  }

  function setComm(comm) {
    //setto globalmente la commissione sulla risposta, altrimenti sarebbe vuota ma non verrebbe più fuori la scelta
    sessionStorage.setItem(Fnc.selCCName, JSON.stringify(comm));
    setSelComm(comm); //setto  anche nella variabile react perché la sessione si aggiorna in asincrono e a volte non lo fa in tempo
  }

  function handleChooseContract(comm) {

    if (!isCommissionSelectable(comm)) {
      sessionStorage.removeItem(Fnc.selCCName);
      setSelComm(null);
      setShowBasket(false);
      return;
    }

    sendCommToBE(comm, () => {

      // === STEP3/B - [CUSTOMER] : chiamo la "customer" per settare la piva nel cookie. Deve essere sincronizzata! ========
      let piva = user.user.pIva;
      API.getCustomer(piva, (custRsp) => {
        if (custRsp && custRsp.response && (custRsp.response.code === 'OK')) {
          setComm(comm);
          setCustomer(custRsp);
          setLoadingState("");
          setShowBasket(true);
        } else {
          // ERRORE
          setStep(-1);
          setLoadingState("");
          setShowBasket(false);
          Fnc.gaException("[App.js@handleChooseContract] Get Customer in KO", JSON.stringify(custRsp), true, Fnc.ExcCatgory.GENERIC.val);
        }
      });

    })
  }

  function callbackFatturazione(data) {
    if (data && data.code === Fnc.EnmGen.OK) {
      setInvoice(data.obj);
      //salvo in sessione i dati fatturazione. Serviranno in alcuni casi nei quali non si possono traferire facilmente
      sessionStorage.setItem(Fnc.invoiceName, JSON.stringify(data.obj));

      if (bskType === Fnc.BasketType.PAY || bskType === Fnc.BasketType.BOTH) {
        //Ho ANCHE dei prodotti che si possono acquistare direttamente
        handleNext();
      } else {
        //ho solo preventivi
        //setLoadingState("open");
        let fpt = Fnc.jsonSerialize(data.obj);

        API.checkoutDirect(fpt, "1111111111111", (data) => {
          Fnc.log("CHECKOUT DIRECT PREVENTIVI OK", data, Fnc.LogLvl.DEBUG);

          if (data && data.response && data.response.code === 'OK') {
            setPayResult(new Fnc.Ret(Fnc.EnmPay.OKDIRECTPREV, data));
            //setLoadingState("");
            setStep(12); //Riepilogo finale
          } else {
            Fnc.log("Checkout direct KO: ", data, Fnc.LogLvl.DEBUG);
            setStep(12); //Riepilogo finale
            Fnc.gaException("[App.js@callbackFatturazione] Checkout direct KO per solo preventivi", JSON.stringify(data), true, Fnc.ExcCatgory.API_CALL.val);
          }

        });

      }

    } else {
      Fnc.log("FATTURAZIONE KO", data, Fnc.LogLvl.DEBUG);
    }
  }

  function callbackMetodiPagamento(data) {
    if (data && (data.code === Fnc.EnmPay.OK || data.code === Fnc.EnmPay.OKDIRECT)) {
      // Il checkout svuota il carrello lato server. Da questo momento eventuali
      // validazioni del basket ancora in corso non devono deviare la pagina finale su /empty.
      checkoutCompletedRef.current = true;
      setPayResult(data);
      sessionStorage.removeItem(Fnc.invoiceName);
      sessionStorage.removeItem(Fnc.selCCName);
      setInvoice(null);
      setSelComm(null);
      handleNext();
    } else {
      Fnc.log("METODI PAGAMENTO KO", data, Fnc.LogLvl.DEBUG);
      Fnc.gaException("[App.js@callbackMetodiPagamento] METODI PAGAMENTO KO", JSON.stringify(data), true, Fnc.ExcCatgory.PAY_METHOD.val);
      handleNext();
    }
  }

  function handleMissingInvoice() {
    setStep(10); // Dati di fatturazione
  }

  function callbackBasket(data) {

    Fnc.log("callbackBasket:", data, Fnc.LogLvl.DEBUG);

    if (checkoutCompletedRef.current) return;

    // IMPORTANTE : salvo la tipologia di basket che serve a cambiare l'interfaccia in diversi punti a seconda se ho prodotti misti o solo pay / prev
    setBskType(data && data.obj && data.obj.type && data.obj.type !== null ? data.obj.type : Fnc.BasketType.PAY);

    //Salvo i prodotti messi nel carrello in sessione. N.B. lo faccio sempre se ce li ho, non solo se carrello è OK,  perché possono servire anche per i tracciamenti e per altre funzioni
    if (data.obj.bskAndProds) {
      sessionStorage.setItem(Fnc.prodListName, JSON.stringify(data.obj.bskAndProds));
    }

    if (data && data.code === Fnc.EnmBasket.OK) {
      setValidBasket(true);
      //setBasketProds(data.obj.bskAndProds); //salvo i prodotti del carrello per la pagina finale


      //setBasket(data.obj.data); 
    } else if (data && data.code === Fnc.EnmBasket.EMPTY_DOMAIN) {
      //sito web senza dominio, va mostrata pagina apposita
      //setBasket(data.obj.data); //salvo il carrello per usarlo nella pagina dominio (dovrò aggiornare properties e rimandare tutto)
      setStep(9); //scelta dominio
      //N.B. non metto il basket invalido perchè semplicemente manca il dominio
    } else if (data && data.code === Fnc.EnmBasket.EMPTY) {
      setValidBasket(false);
      setStep(-2); //carrello vuoto
    } else {
      setValidBasket(false);
    }
  }

  function isTimeToShowBasket() {
    let stepByUrl = Fnc.getStepByUrl();
    return stepByUrl ? stepByUrl.withBasket : false;
  }


  function callbackConfSito(data) {

    if (data.code === Fnc.EnmGen.OK) {
      //SITO accettato
      handleNext();
    } else {
      // ERRORE
      setStep(-1);
      Fnc.gaException("[App.js@callbackConfSito] KO dalla configurazione sito SDIY ", JSON.stringify(data), true, Fnc.ExcCatgory.GENERIC.val);
    }

  }

  //----------- RENDER -----------
  return (

    <>
      <Header />
      <main className="checkout-restyle">
        <StepsViewer currStep={currStep != null ? currStep : defaultStep} user={user} selComm={selComm} bskType={bskType} />
        <div className="iol-checkout-body row">
          <Routes>
            <Route path="/fill" element={<ConfigurazioneSito callback={callbackConfSito} />} />
            <Route path="/pay" element={<DemetraMetodiPagamento handleNext={callbackMetodiPagamento} handleMissingInvoice={handleMissingInvoice} validBasket={validBasket} invoiceData={invoice} user={user} />} />
            <Route path="/" element={<Fatturazione callback={callbackFatturazione} validBasket={validBasket} selComm={selComm} user={user} customer={customer} handleChooseContract={handleChooseContract} bskType={bskType} />} />
            <Route path="/end" element={<OrdineCompletato payResult={payResult} />} />
          </Routes>
          {(payResult == null && showBasket && isTimeToShowBasket()) && <Basket callback={callbackBasket} codComm={selComm} />}
        </div>
      </main>
      <Footer />
      <Loading loadingState={loadingState} />
    </>

  );
}

function readConfirmedInvoiceFromSession() {
  try {
    const storedInvoice = sessionStorage.getItem(Fnc.invoiceName);
    if (!storedInvoice) return null;

    const parsedInvoice = JSON.parse(storedInvoice);
    const hasText = value => typeof value === 'string' && value.trim().length > 0;
    const isConfirmedInvoice = parsedInvoice
      && typeof parsedInvoice === 'object'
      && !Array.isArray(parsedInvoice)
      && parsedInvoice.fCond === true
      && hasText(parsedInvoice.rs)
      && hasText(parsedInvoice.nam)
      && hasText(parsedInvoice.snam)
      && hasText(parsedInvoice.email)
      && hasText(parsedInvoice.city)
      && hasText(parsedInvoice.prov)
      && hasText(parsedInvoice.topo)
      && (hasText(parsedInvoice.iva) || hasText(parsedInvoice.cf));

    if (isConfirmedInvoice) return parsedInvoice;

    sessionStorage.removeItem(Fnc.invoiceName);
    return null;
  } catch (e) {
    sessionStorage.removeItem(Fnc.invoiceName);
    return null;
  }
}

export default App;
